import classNames from 'classnames';
import React from 'react';

import styles from './Icon.module.scss';

export enum IconSizes {
  xs = 'xs',
  ss = 'ss',
  s = 's',
  m = 'm',
  l = 'l',
  none = 'none',
}

export const sizes = {
  [IconSizes.xs]: {
    width: 10,
    height: 10,
  },
  [IconSizes.ss]: {
    width: 15,
    height: 15,
  },
  [IconSizes.s]: {
    width: 20,
    height: 20,
  },
  [IconSizes.m]: {
    width: 25,
    height: 25,
  },
  [IconSizes.l]: {
    width: 100,
    height: 100,
  },
  [IconSizes.none]: {},
};

interface IconProps {
  icon: string;
  size?: IconSizes;
  className?: string;
  spin?: boolean;
}

const Icon = (props: IconProps) => {
  const { icon, size = IconSizes.none, className = null, spin = false } = props;

  // eslint-disable-next-line @typescript-eslint/no-var-requires,@typescript-eslint/no-unsafe-member-access
  const IconSvg = require(`!!@svgr/webpack?-svgo,+titleProp,+ref!@Images/icons/${icon}.svg`)
    .default as React.FunctionComponent<React.SVGProps<SVGSVGElement>>;

  return (
    <IconSvg {...sizes[size]} className={classNames(styles.icon, `icon-${size}`, { [styles.spin]: spin }, className)} />
  );
};

export default Icon;
